module.exports = __webpack_public_path__ + "static/media/6.e92bd4a4.jpg";